import { IPolygon, IPolygons } from './polygons';

export interface IPricesAndPolygonsState {
  data: IPricesAndPolygonsData;
  status: EPricesStatus;
}

export interface IPricesAndPolygonsData {
  prices: IPrices;
  polygons: IPolygon[];
}

export interface IPricesAndPolygonsResponse {
  prices: IPrices;
  polygons: IPolygons[];
}

export enum EPricesStatus {
  Init = 'init',
  Success = 'success',
  Failed = 'failed',
  Loading = 'loading',
}

export interface IPrices {
  tariffs: ITariff[];
  durations: IDuration[];
}

export interface IDuration {
  service: number;
  duration: number;
  parameters: IDurationParameters;
}

export interface IDurationParameters {
  category: number;
  oldServiceType?: EPurpleOldServiceType;
}

export enum EPurpleOldServiceType {
  FreeObject = 'freeObject',
}

export interface ITariff {
  service: number;
  price: number;
  parameters: ITariffParameters;
  limit?: number;
}

export interface ITariffParameters {
  polygon: number;
  categories: number[];
  oldServiceType?: FluffyOldServiceType;
  realtyPrice?: IRealtyPrice;
  abUse?: [];
  multilistingSlotsCount?: {
    from: number;
    to: number;
  };
}

export enum FluffyOldServiceType {
  FreeObject = 'FreeObject',
}

export interface IRealtyPrice {
  operator: Operator;
  value: Array<number | null>;
}

export enum Operator {
  Range = 'range',
}
